/**
 * Get scroll position of given element
 * @param {HTMLElement} elem
 * @returns {[number,number]}
 */
export default function position(elem) {
  let left = 0;
  let top = 0;

  do {
    left += elem.offsetLeft-elem.scrollLeft;
    top += elem.offsetTop-elem.scrollTop;
  } while ( elem === elem.offsetParent );

  return [ left, top ];
}
